import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { adminIntelligence } from "../../lib/adminApi";

export default function AdminIntelligence() {
  const [days, setDays] = useState(14);
  const [data, setData] = useState(null);

  useEffect(() => { adminIntelligence(days).then(setData); }, [days]);

  if (!data) return <div className="p-10 text-white/40">Loading...</div>;

  return (
    <div className="px-5 md:px-10 py-8 max-w-7xl space-y-8" data-testid="admin-intelligence">
      <header className="flex items-end justify-between">
        <div>
          <p className="overline text-[#C17F59] mb-2">Guest Intelligence</p>
          <h1 className="font-display text-4xl">What guests actually did.</h1>
          <p className="text-sm text-white/55 mt-2">Anonymous session-level events from the public Atlas.</p>
        </div>
        <div className="flex gap-1">
          {[7, 14, 30].map((d) => (
            <button key={d} onClick={() => setDays(d)}
                    className={`text-xs uppercase tracking-[0.22em] px-3 py-2 transition-colors ${
                      days === d ? "text-[#C17F59] border-b border-[#C17F59]" : "text-white/50 hover:text-white"
                    }`} data-testid={`intel-${d}d`}>{d}d</button>
          ))}
        </div>
      </header>

      <section className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <Kpi label="Events" value={data.total_events} />
        <Kpi label="Matchmaker started" value={data.matchmaker_started} />
        <Kpi label="Matchmaker done" value={data.matchmaker_done} />
        <Kpi label="Compare pairs" value={data.compare_pairs.length} />
      </section>

      <section className="grid grid-cols-1 lg:grid-cols-2 gap-5">
        <Block title="Most viewed gins">
          {data.most_viewed_gins?.length === 0 && <p className="text-sm text-white/40">No views yet.</p>}
          {data.most_viewed_gins?.map((row) => (
            <Link key={row.gin.id} to={`/admin/menu/${row.gin.id}`}
                  className="flex items-center justify-between py-2 border-b border-white/5 hover:bg-white/3 transition-colors px-2 -mx-2">
              <div>
                <p className="font-display text-base">{row.gin.name}</p>
                <p className="text-[10px] uppercase tracking-[0.2em] text-white/40">{row.gin.country}</p>
              </div>
              <span className="font-display text-2xl text-[#C17F59]">{row.count}</span>
            </Link>
          ))}
        </Block>

        <Block title="Top searches">
          {data.most_searched.length === 0 && <p className="text-sm text-white/40">No searches yet.</p>}
          {data.most_searched.map(([q, c]) => (
            <div key={q} className="flex items-center justify-between py-2 border-b border-white/5">
              <span className="font-display text-base">"{q}"</span>
              <span className="font-display text-2xl text-[#C17F59]">{c}</span>
            </div>
          ))}
        </Block>

        <Block title="Top filters">
          {data.most_filters.map(([f, c]) => (
            <div key={f} className="flex items-center justify-between py-2 border-b border-white/5">
              <span className="text-sm">{f.replace(":", " · ")}</span>
              <span className="text-base text-[#C17F59]">{c}</span>
            </div>
          ))}
        </Block>

        <Block title="Compare pairs">
          {data.compare_pair_gins?.length === 0 && <p className="text-sm text-white/40">No comparisons yet.</p>}
          {data.compare_pair_gins?.map((p, i) => (
            <div key={i} className="flex items-center justify-between py-2 border-b border-white/5">
              <span className="text-sm">{p.a.name} <span className="text-[#C17F59]">↔</span> {p.b.name}</span>
              <span className="text-base text-[#C17F59]">{p.count}</span>
            </div>
          ))}
        </Block>
      </section>
    </div>
  );
}

function Kpi({ label, value }) {
  return (
    <div className="bg-[#15171A] border border-white/8 p-4">
      <p className="overline text-white/40">{label}</p>
      <p className="font-display text-3xl text-[#C17F59] mt-1">{value}</p>
    </div>
  );
}
function Block({ title, children }) {
  return (
    <div className="bg-[#15171A] border border-white/8 p-5">
      <p className="overline text-[#C17F59] mb-3">{title}</p>
      <div>{children}</div>
    </div>
  );
}
